import { BFX_FIND_TIMEZONE_CD_UTC, FilterData } from "./bfx-find.constants";
import { BfxFindFilterCondition } from "./models/BfxFindFilterCondition";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  BfxFindFilterConditionValueParseType,
  BfxFindOrdersFilterFieldName,
  CustomFieldLookupService,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
import { BfxFindFilterOperatorSet } from "app/bfx-find/models/BfxFindFilterOperatorSet";
const logger = LoggerService.for(__dirname);

export interface BfxFindFilterData {
  data: FilterData[];

  // keep in case contraint maps or similar are resurrected -dc
}

export abstract class BfxFindFilterDataFactory {
  constructor(private customFieldService: CustomFieldLookupService) {}

  public abstract defineFilterData(...defineArgs): BfxFindFilterData;

  public defaultTimezoneField(data): void {
    data.forEach((fd: FilterData, i) => {
      if (fd != null && fd.filterConditions != null && Array.isArray(fd.filterConditions)) {
        fd.filterConditions.forEach((fc: BfxFindFilterCondition) => {
          if (fc.fieldName == BfxFindOrdersFilterFieldName.SEARCH_IN_TZ) {
            fc.value = BFX_FIND_TIMEZONE_CD_UTC;
            fc.operatorData = { label: "=", value: CubiqTS.Operator.Equal };
          }
        });
      } else if (fd != null) {
        logger.out.warn(
          `${this.constructor.name}: Filter does not have filter conditions ${fd.id} ${fd.label}`,
        );
      }
    });
  }

  /**
   * Create the filter data associated with the Custom Fields section, incuding an attribute
   * for every active custom field. If no custom fields exist, then this will return null
   * @returns
   */
  protected getCustomFieldSearchData(): any {
    const customFieldDefns = this.customFieldService.getActiveCustomFields();
    if (!customFieldDefns || customFieldDefns.length == 0) {
      return null;
    }

    const conditions: BfxFindFilterCondition[] = [];

    const retData = {
      id: FilterData.templateId++,
      label: "Search by Custom Fields",
      filterConditions: conditions,
    };

    for (let i = 0; i < customFieldDefns.length; i++) {
      const defn = customFieldDefns[i];

      const parseType = defn.freeFormatTxtFg
        ? BfxFindFilterConditionValueParseType.RefString
        : BfxFindFilterConditionValueParseType.None;

      const operators = defn.freeFormatTxtFg
        ? BfxFindFilterOperatorSet.EqualNotEqual
        : BfxFindFilterOperatorSet.InNotIn;

      conditions.push(
        new BfxFindFilterCondition(
          9,
          i,
          this.customFieldService.getEntityPropertyName(defn),
          defn.displayName,
          operators,
          parseType,
        ),
      );
    }
    return retData;
  }
}
